import { Stack } from '@mui/material';
import AttrField from './AttrField';
import PixelField from './PixelField';
import { useTranslation } from 'react-i18next';

type NameCase = 'camel' | 'kebab';

interface PaddingFieldsProps {
    name: string;
    nameCase?: NameCase;
    // ...other props
}

const nameSuffixes = {
    camel: {
        top: 'Top',
        right: 'Right',
        bottom: 'Bottom',
        left: 'Left',
    },
    kebab: {
        top: '-top',
        right: '-right',
        bottom: '-bottom',
        left: '-left',
    },
};

function PaddingFields({ name, nameCase = 'camel', ...props }) {
    const { t } = useTranslation();

    return (
        <Stack spacing={2}>
            <Stack direction="row" spacing={2}>
                <AttrField
                    Component={PixelField}
                    name={name + nameSuffixes[nameCase].top}
                    placeholder={t('Top')}
                    label={t('Top')}
                    {...props}
                />
                <AttrField
                    Component={PixelField}
                    name={name + nameSuffixes[nameCase].bottom}
                    placeholder={t('Bottom')}
                    label={t('Bottom')}
                    {...props}
                />
            </Stack>
            <Stack direction="row" spacing={2}>
                <AttrField
                    Component={PixelField}
                    name={name + nameSuffixes[nameCase].left}
                    placeholder={t('Left')}
                    label={t('Left')}
                    {...props}
                />
                <AttrField
                    Component={PixelField}
                    name={name + nameSuffixes[nameCase].right}
                    placeholder={t('Right')}
                    label={t('Right')}
                    {...props}
                />
            </Stack>
        </Stack>
    );
}

export default PaddingFields;
